import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { Card, Col, Container } from 'reactstrap'
import { BackButton } from '../../../components/Common/BackButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import { SearchBar } from '../../../components/Common/SearchBar'
import Table1 from "../../../components/Common/TableContainer"
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { addNewLabSegment, deleteLabSegment, getLabSegments, updateLabSegment, updateLabSegmentStatus } from '../../../store/actions'
import { LabSegmentRegisterModal } from './LabSegmentRegisterModal';

export const CatalogLayoutLabSegment = (props) => {

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLabSegments("?limit=20&page=0"))
    }, [])

    const { labsegments, loading, total, currentPage } = useSelector(state => ({
        labsegments: state.labSegments.labsegments,
        loading: state.labSegments.loading,
        labsegment: state.labSegments.labsegment,
        total: state.labSegments.total,
        currentPage: state.labSegments.currentPage,
    }));
    // * Redux fin

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getLabSegments(`?limit=20&page=0&search=${searchData}`))
    }, [searchData])

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Segmento Laboratorio',
                accessor: 'name',
                width: 400,
            },
            {
                Header: 'Estatus',
                width: '15%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateLabSegment(updValue))
            dispatch(updateLabSegmentStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            dispatch(addNewLabSegment(values))
        }
        setTimeout(() => {
            dispatch(getLabSegments("?limit=20&page=0"))
        }, 500)
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteLabSegment(rowInfo))
        setRowInfo('')
    }

    const getPagination = (params) => {
        dispatch(getLabSegments(`${params}&search=${searchData}`))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 50 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='SegmentCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labsegments} />
                                </div>
                                
                                <LabSegmentRegisterModal
                                    rowInfo={rowInfo}
                                    isUpdate={isUpdate}
                                    modalRespInfo={RegisterModalRespInfo}
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    modalClose={modalClose}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar segmentos' modalBodyLabel='¿Está seguro que desea eliminar el segmento seleccionado?' />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(CatalogLayoutLabSegment)

// CatalogLayoutLabSegment.propTypes = {
//     error: PropTypes.any,
//     getLabTypes: PropTypes.func,
// }
